import { Flex } from '@fluentui/react-northstar';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmptySVG from '../../../../svg/empty.svg';
import { appState, useSetState } from '../../../AppState';
import { ADD_APPROVALS_NOTE, ADMINISTRATORS, ANALYSTS, MyWorkListViewType, TicketApprovalState } from '../../utils/constants';
import { EmptyData } from '../EmptyData';
import { ApprovalsDialog } from './ApprovalsDialog';
import { TicketApprovalCard } from './TicketApprovalCard';

interface Props {
  ticketApprovals: TicketApprovals[];
  currentUserId: number;
  updateApprovalStatus?: (ticketApprovalData: Approval, approverId: number, status: TicketApprovalState) => void;
  isTicketClosed: boolean;
  isLifecycleEnabled?: boolean;
  isEndUser?: boolean;
  disableButonOnUpdate?: boolean;
  addTicketApprovals?: (ticketApprovalsData: Approval) => void;
  updateTicketApproval?: (ticketApprovalsData: Approval) => void;
  setApproversList?: (value: PlatformUser[]) => void;
  approversList?: PlatformUser[];
  isLoaded?:boolean;
}


export const TicketApprovalsList = ({
    ticketApprovals, 
    currentUserId, 
    updateApprovalStatus, 
    isTicketClosed, 
    isLifecycleEnabled = false, 
    disableButonOnUpdate = false, 
    isEndUser = false, 
    addTicketApprovals, 
    updateTicketApproval, 
    setApproversList, 
    approversList,
    isLoaded
  }: Props) => {

  const {t} = useTranslation();  

  const [openApprovalDialog, setOpenApprovalDialog] = useState<boolean>(false);
  const [selectedApprovalData, setSelectedApprovalData] = useState<any>();
  
  const setAppState = useSetState();
  const currentState = appState();
  
  const onApprovalClick = (approvalDetail: Approval) => {
    setSelectedApprovalData({...approvalDetail});
    setOpenApprovalDialog(true);
  };

  const isEditable = (approvalState: any) =>{
    const hasAccess = currentState.userRoles.roles.includes(ADMINISTRATORS) || currentState.userRoles.roles.includes(ANALYSTS) 
    return hasAccess && approvalState == TicketApprovalState.Pending && !isTicketClosed;
  }

  useEffect(()=>{
    const { isRouteFromMyWork, selectedTaskOrApproval } = currentState;
      if (isRouteFromMyWork && selectedTaskOrApproval?.type === MyWorkListViewType.Approvals) {
        setAppState((prev) => ({ ...prev, isRouteFromMyWork: false }));
      }
  },[isLoaded]);

  return (
    <div className='mt-2'>
      {ticketApprovals?.length > 0 ?
        (ticketApprovals.map((approval: TicketApprovals) => (
          <div key={approval.Approval.Id} className={`mt-4 ${(isEditable(approval.Approval.ApprovalState) && !isEndUser) ? 'cursor-pointer' : ''}`} 
                    onClick={(e) => { 
                      if (isEditable(approval.Approval.ApprovalState) && !isEndUser)
                        onApprovalClick(approval.Approval) 
                      else
                        e.stopPropagation();
                    }}>
            <TicketApprovalCard 
              key={approval.Approval.Id}
              approval={approval.Approval}
              ticketApprovalId={approval.Id}
              currentUserId={currentUserId}
              updateApprovalStatus={updateApprovalStatus}
              isTicketClosed={isTicketClosed}
              isLifecycleEnabled={isLifecycleEnabled}
              disableButonOnUpdate={disableButonOnUpdate}
            />
          </div>
        ))) : 
        <Flex className='mt-5' >
          <Flex.Item grow className="pt-0 overflow-auto"></Flex.Item>
          <EmptyData
            subheaderText={isEndUser ? '' : ADD_APPROVALS_NOTE}
            headerText={t('ticket-details.edit-ticket-form.approval.empty-approval-list')}
            SVGIcon={<EmptySVG width={75} height={75} />}
          />
        </Flex>
      }
      <ApprovalsDialog
        open={openApprovalDialog}
        onCancel={() => setOpenApprovalDialog(false)}
        approversList={approversList}
        setApproversList={setApproversList}
        addTicketApprovals={addTicketApprovals}
        existingTicketApprovalData = {selectedApprovalData}
        isUpdateButton = {true}
        updateTicketApproval = {updateTicketApproval}
      />
    </div>
  );
};
